import * as React from 'react';

import * as style from './MainInfoLayout.css';

export interface IMainInfoLayoutProps {
  title: React.ReactElement;
  subtitle: React.ReactElement;
  newbuildingOverallRating: React.ReactElement;
  newbuildingRatings: React.ReactElement;
  newbuildingNameFormatted: string;
}

export const MainInfoLayout: React.FC<IMainInfoLayoutProps> = props => {
  const { title, subtitle, newbuildingOverallRating, newbuildingRatings, newbuildingNameFormatted } = props;

  return (
    <div itemScope itemType="http://schema.org/Product" data-testid="MainInfoLayout" className={style['container']}>
      <meta itemProp="name" content={newbuildingNameFormatted} />
      <div className={style['title']}>
        {title}
        {subtitle}
      </div>
      <div className={style['overall-rating']}>{newbuildingOverallRating}</div>
      <div className={style['ratings']}>{newbuildingRatings}</div>
    </div>
  );
};
